define('display/imagePath',[], function () {
    "use strict";

    function getBasePath() {
        var scripts = document.getElementsByTagName("script"),
            pattern = /(.*)tomtom.min.js/,
            i;
        for (i = scripts.length - 1; i > 0; i -= 1) {
            if (scripts[i].src) {
                var path = pattern.exec(scripts[i].src);
                if (path) {
                    return path[1];
                }
            }
        }
        return "";
    }

    return {
        get: function () {
            return getBasePath() + "images";
        }
    };
});
